var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('GmapMap',{staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.opts,"center":{lat: _vm.lat,
						lng: _vm.lng},"zoom":14}},[_c('gmap-custom-marker',{attrs:{"marker":{ lat: _vm.lat, lng: _vm.lng },"alignment":"center"}},[_c('img',{attrs:{"src":"/hive-pin.png"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }